import { render, staticRenderFns } from "./breath.vue?vue&type=template&id=7dc19132&scoped=true&"
import script from "./breath.vue?vue&type=script&lang=js&"
export * from "./breath.vue?vue&type=script&lang=js&"
import style0 from "./breath.vue?vue&type=style&index=0&id=7dc19132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc19132",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dc19132')) {
      api.createRecord('7dc19132', component.options)
    } else {
      api.reload('7dc19132', component.options)
    }
    module.hot.accept("./breath.vue?vue&type=template&id=7dc19132&scoped=true&", function () {
      api.rerender('7dc19132', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/breath.vue"
export default component.exports